export class DeveloperConstants {
  public static readonly IS_DEVELOPER_MODE = "__dC7CzvnkTYbBBkfSuNry59wbnBK3e2d9nppVLbJ8NWPm5u9hn6X2f7rTCPaXyRvzTbqQBDnhzqt3tjfc75yVTzAPHdkMZfUxwbtg699GHxysv4CFfsLGSrbQfxSdkbCxVJamJ2YuCRJVcedC4SSuCECrKZMKRcQD2p4YTys7pMEt4b7WtKhvSMvKzgRhGyVm47va9PKZnnuptDukwguccJach9sU8w3nGkBx6xznp3NHjEXkjpFXyT6BZk6XqB6d";
}
